import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import '../styles/Landing.css';

function Landing() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
      setLoading(false);
    };
    checkAuth();
  }, []);

  const handleTrackerClick = () => {
    if (user) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="landing-container">
      <div className="landing-hero">
        <div className="hero-content">
          <h1 className="hero-title">KVM & Co.</h1>
          <h2 className="hero-subtitle">Free Fatty Acid Testing Laboratory</h2>
          <p className="hero-location">Mysore, India</p>
          <p className="hero-description">
            Professional FFA testing services for sesame oil quality assessment. 
            Trusted by exporters and manufacturers for accurate, reliable results.
          </p>
          <button 
            className="tracker-button" 
            onClick={handleTrackerClick}
            disabled={loading}
          >
            {loading ? 'Loading...' : 'Test Tracker →'}
          </button>
        </div>
      </div>

      <div className="landing-services">
        <div className="services-content">
          <h2 className="section-title">Our Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🧪</div>
              <h3>FFA Testing</h3>
              <p>Accurate Free Fatty Acid analysis using industry-standard titration methods</p>
            </div>
            <div className="service-card">
              <div className="service-icon">📊</div>
              <h3>Quality Reports</h3>
              <p>Detailed test reports with FFA percentage calculations and moisture content</p>
            </div>
            <div className="service-card">
              <div className="service-icon">⚡</div>
              <h3>Quick Turnaround</h3>
              <p>Same-day testing and reporting for urgent requirements</p>
            </div>
            <div className="service-card">
              <div className="service-icon">✅</div>
              <h3>Certified Process</h3>
              <p>Following international standards for oil quality testing</p>
            </div>
          </div>
        </div>
      </div>

      <div className="landing-contact">
        <div className="contact-content">
          <h2 className="section-title">Contact Us</h2>
          <p className="contact-intro">For your FFA testing needs, get in touch with us today</p>
          
          <div className="contact-grid">
            <a href="mailto:vijay@kvmmail.com" className="contact-card">
              <div className="contact-icon">✉️</div>
              <div className="contact-details">
                <h4>Email</h4>
                <p>vijay@kvmmail.com</p>
              </div>
            </a>

            <a href="tel:+919945066555" className="contact-card">
              <div className="contact-icon">📱</div>
              <div className="contact-details">
                <h4>Phone</h4>
                <p>+91 9945066555</p>
              </div>
            </a>

            <a href="https://www.kvmmysore.in" target="_blank" rel="noopener noreferrer" className="contact-card">
              <div className="contact-icon">🌐</div>
              <div className="contact-details">
                <h4>Website</h4>
                <p>www.kvmmysore.in</p>
              </div>
            </a>

            <a href="https://maps.app.goo.gl/CKN5tT5y9x2CkJot8" target="_blank" rel="noopener noreferrer" className="contact-card">
              <div className="contact-icon">📍</div>
              <div className="contact-details">
                <h4>Location</h4>
                <p>View on Google Maps</p>
              </div>
            </a>
          </div>
        </div>
      </div>

      <footer className="landing-footer">
        <p>© 2024 KVM & Co. - Excellence in Oil Quality Testing</p>
      </footer>
    </div>
  );
}

export default Landing;